import { createContext, useContext, useState, useCallback } from 'react';
import pt from './pt';
import es from './es';
import en from './en';

const DICTS = { pt, es, en };
export const IDIOMAS = [
  { id: 'pt', label: 'PT', nome: 'Português' },
  { id: 'es', label: 'ES', nome: 'Español' },
  { id: 'en', label: 'EN', nome: 'English' },
];

// Detecta o idioma: preferência salva > idioma do navegador (pt-* → pt, en-* → en, resto → es)
function detectarIdioma() {
  const salvo = localStorage.getItem('idioma');
  if (salvo === 'pt' || salvo === 'es' || salvo === 'en') return salvo;
  const nav = (navigator.language || 'pt').toLowerCase();
  if (nav.startsWith('pt')) return 'pt';
  if (nav.startsWith('en')) return 'en';
  return 'es';
}

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [idioma, setIdiomaState] = useState(detectarIdioma);

  const setIdioma = useCallback((novo) => {
    if (novo !== 'pt' && novo !== 'es' && novo !== 'en') return;
    localStorage.setItem('idioma', novo);
    setIdiomaState(novo);
    document.documentElement.lang = novo === 'es' ? 'es' : novo === 'en' ? 'en' : 'pt-BR';
  }, []);

  // t('login.form_titulo') ou t('login.erro_generico', { status: 500 })
  const t = useCallback((chave, vars) => {
    const buscar = (dict) =>
      String(chave).split('.').reduce((o, k) => (o == null ? undefined : o[k]), dict);
    let valor = buscar(DICTS[idioma]);
    if (valor == null) valor = buscar(DICTS.pt);
    if (valor == null) return chave;
    if (vars && typeof valor === 'string') {
      valor = valor.replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : m));
    }
    return valor;
  }, [idioma]);

  return (
    <LanguageContext.Provider value={{ idioma, setIdioma, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useT precisa estar dentro de <LanguageProvider>');
  return ctx;
}
